import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setEditModal } from "../../../../reduxToolkit/reducers/bookmarkTabsSlice";
import BookmarkFormModal from "./common/BookmarkFormModal";

//Modal for editing the bookmark.
const EditBookmark = () => {
  const { editRow, editModal } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();

  return <BookmarkFormModal isOpen={editModal} toggle={() => dispatch(setEditModal())} initialData={editRow} />;
};
export default EditBookmark;
